module.exports = __webpack_public_path__ + "media/fox.880a1483.wav";